import { alpha, fontSize, maxWidth, width } from "@mui/system";

const styles = (theme) => ({
  titlePopper: {
    fontWeight: "bold",
    fontSize: 14,
    color: alpha(theme.palette.text.primary, 0.6),
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  boxTitlePopper: {
    p: 1,
    borderBottom: `1px solid ${theme.palette.grey[800]}`,
    display: "flex",
    alignItems: "center",
    gap: 1,
    justifyContent: "space-between",
  },
  iconTitle: {
    color: alpha(theme.palette.text.primary, 0.6),
    fontSize: 18,
  },
  iconTitleoS: {
    color: alpha(theme.palette.text.primary, 0.6),
    fontSize: 18,
  },
  paperPopper: {
    mt: 1,
    width: 525,
    borderRadius: 2,
    overflow: "hidden",
    backgroundColor:
      theme.palette.mode === "light"
        ? theme.palette.white.main
        : theme.palette.grey[900],
  },
  popper: { zIndex: 1300 },
  listPopper: {
    maxHeight: 250,
    overflow: "auto",
    p: 0,
  },
  iconPopper: {
    fontSize: 25,
    color: theme.palette.primary.main,
  },
  iconPopperOs: {
    fontSize: 25,
    color: "red",
  },
  boxMenuItem: {
    display: "flex",
    gap: 1,
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
  },
  title: {
    fontWeight: 600,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "block",
  },
  description: {
    display: "block",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  chip: {
    fontWeight: "bold",
    borderRadius: "8px", // Bordas levemente quadradas dão um ar mais "Gestão/Enterprise"
    backgroundColor: (theme) =>
      theme.palette.mode === "light"
        ? theme.palette.colors.orange.lighter
        : alpha(theme.palette.colors.orange.darker, 0.2),
    color: (theme) =>
      theme.palette.mode === "light"
        ? theme.palette.colors.orange.dark
        : theme.palette.colors.orange.medium,
    border: "1px solid",
    borderColor: (theme) =>
      theme.palette.mode === "light"
        ? theme.palette.colors.orange.dark
        : theme.palette.colors.orange.medium,
  },
  containerHandleScript: { maxHeight: 300, overflow: "auto", p: 0 },
  containerActions: {
    display: "flex",
    gap: 1,
    justifyContent: "flex-end",
    p: 1,
  },
  containerTextField: {
    display: "flex",
    gap: 1,
    flexDirection: "column",
    p: 1,
    width: "100%",
  },
  boxIcon: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  menuItem: {
    flexDirection: "column",
    alignItems: "flex-start",
    py: 1,
    borderBottom: `1px solid ${theme.palette.mode === "light" ? theme.palette.grey[200] : theme.palette.grey[800]}`,
  },
});

export default styles;
